module.exports = __webpack_public_path__ + "static/media/briDelph.73bb0bac.jpg";